import NextLink from 'next/link';
import {useContext} from 'react';

import useIsMobile from '@/src/hooks/useIsMobile';
import ClinicPositionsFilter from '@/src/jobPortal/clinicPositions/containers/ClinicPositionsFilter';
import {jopPositionsFilterProps} from '@/src/jobPortal/clinicPositions/hooks/useClinicPositions';
import css from '@/src/jobPortal/clinicPositions/styles/filters.module.css';
import {NEW_POSITION} from '@/src/jobPortal/common/containers/SinglePositionBootstrap';
import RouteContext from '@/src/routes/utils/RouteContext';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Text} from '@/src/ui';

interface ClinicPositionsSidebarLayoutProps {
  filter: jopPositionsFilterProps;
  onMobileFilterClick: (...args: any[]) => any;
  onClearClick: (...args: any[]) => any;
}

const ClinicPositionsSidebarLayout = ({
  filter,
  onMobileFilterClick,
  onClearClick,
}: ClinicPositionsSidebarLayoutProps) => {
  // @ts-ignore
  const {JOB_PORTAL_MY_POSITION_EDIT} = useContext(RouteContext);
  const {isMaxWidth1100} = useIsMobile();

  return isMaxWidth1100 ? (
    <div className={css.mobileActionButtons}>
      <div className={css.mobileFilterButton}>
        <Button
          onClick={onMobileFilterClick}
          color={Button.COLOR.SECONDARY}
          height={Button.HEIGHT.SMALL}
          border={Button.BORDER.BOLD}
        >
          <span className={css.mobileFilterButtonText}>
            <TextLocal id={'search.filters'} />
          </span>
        </Button>
        <span className={css.mobileFilterCounter}>
          {Object.values(filter).length}
        </span>
      </div>

      <NextLink href={JOB_PORTAL_MY_POSITION_EDIT.getLink(NEW_POSITION)}>
        <a>
          <Button height={Button.HEIGHT.SMALL}>
            <TextLocal id={'job-portal.add-positions'} />
          </Button>
        </a>
      </NextLink>
    </div>
  ) : (
    <div className={css.sidebar}>
      <div className={css.filterGroupWrapper}>
        <div onClick={onClearClick} className={css.clearButton}>
          <Text
            color={Text.COLOR.GREY}
            fontWeight={Text.FONT_WEIGHT.MEDIUM}
            fontSize={Text.FONT_SIZE.SIZE_16}
          >
            <TextLocal id={'search.clearAll'} />
          </Text>
        </div>
      </div>
      <ClinicPositionsFilter />
    </div>
  );
};

export default ClinicPositionsSidebarLayout;
